<template>
    <v-container fluid class="incidente-root">
        <h2>Distribución por ciudad y grado</h2>

        <!-- FILTROS -->
        <v-card class="pa-3 mb-3 filtros-card" outlined>
            <v-row dense>
                <v-col cols="12" md="4">
                    <v-text-field v-model="search" label="Buscar" append-icon="mdi-magnify" outlined dense clearable />
                </v-col>
                <v-col cols="12" md="3">
                    <v-autocomplete v-model="filtros.oid_ciudad" :items="LCiudad" item-text="nombre" item-value="oid" label="Ciudad" outlined dense multiple clearable />
                </v-col>
                <v-col cols="12" md="3">
                    <v-autocomplete v-model="filtros.oid_grado" :items="Lgrado" item-text="nombre" item-value="oid" label="Grado" outlined dense multiple clearable />
                </v-col>
            </v-row>
        </v-card>

        <!-- BOTONES -->
        <v-row class="mb-3" align="center">
            <v-col cols="6">
                <v-btn small color="#5e672c" dark @click="listar">
                    <v-icon left small>mdi-refresh</v-icon>
                    Actualizar
                </v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
                <v-btn small color="#e4b510" dark @click="exportarExcel">
                    <v-icon left small>mdi-microsoft-excel</v-icon>
                    Exportar XLSX
                </v-btn>
            </v-col>
        </v-row>

        <!-- TABLA -->
        <v-card class="tabla-card">
            <div class="tabla-wrap">
                <table class="rep-table">
                    <thead>
                        <tr>
                            <th class="sticky-col">CIUDAD</th>                            
                            <th v-for="grado in gradosVisibles" :key="'head-' + grado.oid"> {{ grado.nombre }} </th>
                            <th>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="fila in tablaDistribucion" :key="'fila-' + fila.oid_ciudad">
                            <td class="sticky-col font-weight-bold"> {{ fila.ciudad }} </td>
                            <td v-for="grado in gradosVisibles" :key="'cell-' + fila.oid_ciudad + '-' + grado.oid" >
                                {{ fila.grados[grado.oid] || 0 }}
                            </td>
                            <td class="total-cell">
                                {{ fila.total }}
                            </td>
                        </tr>
                        <tr class="total-row">
                            <td class="sticky-col">TOTAL</td>
                            <td v-for="grado in gradosVisibles" :key="'total-' + grado.oid">
                                {{ totalPorGrado[grado.oid] || 0 }}
                            </td>
                            <td>{{ totalGeneral }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
import {
    setDatos,
    getCiudades,
    getCiudadN
} from '@/utils/catalogo';
import { utils, writeFileXLSX  } from 'xlsx';

export default {
    data() {
        return {
            datos: [],
            Lgrado: [],
            LCiudad: [],
            search: '',
            filtros: {
                oid_ciudad: [],
                oid_grado: []
            },
            loading: false
        };
    },

    computed: {
        datosFiltrados() {
            let data = this.datos || [];

            const search = (this.search || '').toLowerCase().trim();

            if (search) {
                data = data.filter(x => {
                    const texto = `
                        ${x.nombres || ''}
                        ${x.primero_apellido || ''}
                        ${x.segundo_apellido || ''}
                        ${x.documento || ''}
                        ${getCiudadN(x.oid_ciudad) || ''}
                    `.toLowerCase();

                    return texto.includes(search);
                });
            }

            if (this.filtros.oid_ciudad.length > 0) {
                data = data.filter(x =>
                    this.filtros.oid_ciudad.map(Number).includes(Number(x.oid_ciudad))
                );
            }

            if (this.filtros.oid_grado.length > 0) {
                data = data.filter(x =>
                    this.filtros.oid_grado.map(Number).includes(Number(x.oid_grado))
                );
            }

            return data;
        },

        gradosVisibles() {
            const usados = new Set(
                this.datosFiltrados
                    .map(x => Number(x.oid_grado))
                    .filter(x => x)
            );

            return (this.Lgrado || [])
                .filter(g => usados.has(Number(g.oid)))
                .sort((a, b) => Number(a.oid) - Number(b.oid));
        },

        tablaDistribucion() {
            const map = {};

            this.datosFiltrados.forEach(item => {
                const oidCiudad = item.oid_ciudad || 0;
                const oidGrado = item.oid_grado || 0;

                if (!map[oidCiudad]) {
                    map[oidCiudad] = {
                        oid_ciudad: oidCiudad,
                        ciudad: getCiudadN(oidCiudad) || 'Sin ciudad',
                        grados: {},
                        total: 0
                    };
                }

                map[oidCiudad].grados[oidGrado] =
                    (map[oidCiudad].grados[oidGrado] || 0) + 1;

                map[oidCiudad].total++;
            });

            return Object.values(map)
                .sort((a, b) => a.ciudad.localeCompare(b.ciudad));
        },

        totalPorGrado() {
            const total = {};

            this.datosFiltrados.forEach(item => {
                const oidGrado = item.oid_grado || 0;
                total[oidGrado] = (total[oidGrado] || 0) + 1;
            });

            return total;
        },

        totalGeneral() {
            return this.datosFiltrados.length;
        }
    },

    async mounted() {
        await setDatos();
        this.LCiudad = getCiudades();

        await this.cargarGrados();
        await this.listar();
    },

    methods: {
        async cargarGrados() {
            const response = await axios.get('api/Grados/Listar');
            this.Lgrado = response.data || [];
        },

        async listar() {
            try {
                this.loading = true;

                const pageSize = 1000;
                let page = 1;
                let total = 0;
                let todos = [];

                do {
                    const response = await axios.get('api/PersonaInfoGenerals/ListarCompleto', {
                        params: {
                            page,
                            pageSize
                        }
                    });

                    const data = response.data.data || [];
                    total = response.data.total || 0;

                    todos = todos.concat(data);
                    page++;
                } while (todos.length < total);

                this.datos = todos;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        exportarExcel() {

            const filas = [];

            // Encabezado
            const encabezado = {
                CIUDAD: 'CIUDAD'
            };

            this.gradosVisibles.forEach(g => {
                encabezado[g.nombre] = g.nombre;
            });

            encabezado.TOTAL = 'TOTAL';

            filas.push(encabezado);

            // Detalle
            this.tablaDistribucion.forEach(fila => {

                const row = {
                    CIUDAD: fila.ciudad
                };

                this.gradosVisibles.forEach(g => {
                    row[g.nombre] = fila.grados[g.oid] || 0;
                });

                row.TOTAL = fila.total;

                filas.push(row);

            });

            // Totales
            const total = {
                CIUDAD: 'TOTAL'
            };

            this.gradosVisibles.forEach(g => {
                total[g.nombre] = this.totalPorGrado[g.oid] || 0;
            });

            total.TOTAL = this.totalGeneral;

            filas.push(total);

            const ws = utils.json_to_sheet(filas, {
                skipHeader: true
            });

            // Anchos de columnas
            ws["!cols"] = [
                { wch: 40 },
                ...this.gradosVisibles.map(() => ({ wch: 12 })),
                { wch: 12 }
            ];

            const wb = utils.book_new();

            utils.book_append_sheet(
                wb,
                ws,
                "Distribucion"
            );

            writeFileXLSX(
                wb,
                `Distribucion_Funcionarios_${new Date().toISOString().substring(0,10)}.xlsx`
            );

        }
    }
};
</script>

<style scoped>
.rep-root {
    background: #f7f8f3;
    min-height: calc(100vh - 80px);
    padding: 20px;
}

h2 {
    color: #5e672c;
    font-size: 28px;
    font-weight: 800;
    margin-bottom: 16px;
}

.filtros-card {
    border-radius: 14px !important;
    background: #ffffff !important;
}

.tabla-card {
    border-radius: 14px !important;
    overflow: hidden;
}

.tabla-wrap {
    overflow: auto;
    max-height: 75vh;
}

.rep-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    font-size: 13px;
}

.rep-table th {
    background: #8fd0df;
    color: #000;
    font-weight: 800;
    text-align: center;
    border: 1px solid #333;
    padding: 8px;
    white-space: nowrap;
}

.rep-table td {
    border: 1px solid #333;
    padding: 6px 8px;
    text-align: center;
    white-space: nowrap;
}

.rep-table td:first-child {
    text-align: left;
}

.sticky-col {
    position: sticky;
    left: 0;
    z-index: 2;
    background: #ffffff;
}

thead .sticky-col {
    background: #8fd0df;
    z-index: 4;
}

.total-cell {
    font-weight: 800;
}

.total-row {
    font-weight: 800;
    background: #f5f5f5;
}

.total-row .sticky-col {
    background: #f5f5f5;
}
</style>